exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-section[data-v-639516ee] {\r\n    margin-bottom: 0px;\n}\n.filter-section h5[data-v-639516ee] {\r\n    margin-top: 0;\r\n    margin-bottom: 0px;\r\n    font-weight: 500;\n}\r\n", ""]);

// exports
